import { apiClient } from '../shared/api-client';

const userRepository = {
    async getGeo() {
        const data = await apiClient.get({
            url: 'users/geo'
        });

        return data;
    }
};

export {
    userRepository
};
